import type { IGetSitePresetParams, IPresetResponse } from '@module/apis/client-side/preset/type';
import { fetchExtended } from '@module/utils/fetch/client-fetch';

export const getSitePreset = async (param: IGetSitePresetParams) => {
  const res = await fetchExtended(`/v1/config/preset?hostname=${param.hostname ?? ''}`, {
    method: 'GET',
    credentials: 'omit',
  });
  const result = await res.json();
  return result as IPresetResponse;
};
